import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from './stores/authStore';
import { useEffect } from 'react';
import { stompClient } from './websocket/stompClient';

// Components
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import DeckBuilderPage from './pages/DeckBuilderPage';
import LobbyPage from './pages/LobbyPage';
import GamePage from './pages/GamePage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminGamesPage from './pages/AdminGamesPage';
import AdminSubscribersPage from './pages/AdminSubscribersPage';
import ProfilePage from './pages/ProfilePage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated) {
      // Connect to WebSocket when authenticated
      stompClient.connect()
        .then(() => console.log('WebSocket connected successfully'))
        .catch((error) => console.error('WebSocket connection failed:', error));
    } else {
      // Disconnect when not authenticated
      stompClient.disconnect();
    }

    return () => {
      // Don't disconnect on every render, only on unmount
    };
  }, [isAuthenticated]);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-[#0b0b12] text-zinc-200">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              path="/*"
              element={
                isAuthenticated ? (
                  <Layout>
                    <Routes>
                      <Route path="/" element={<DashboardPage />} />
                      <Route path="/decks" element={<DeckBuilderPage />} />
                      <Route path="/lobby" element={<LobbyPage />} />
                      <Route path="/game/:matchId" element={<GamePage />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/admin/users" element={<AdminUsersPage />} />
                      <Route path="/admin/games" element={<AdminGamesPage />} />
                      <Route path="/admin/subscribers" element={<AdminSubscribersPage />} />
                    </Routes>
                  </Layout>
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
